// extracted by mini-css-extract-plugin
module.exports = {"meal":"MealItem_meal__3Ei9K","description":"MealItem_description__2WXQs","price":"MealItem_price__3JN_D"};